import { Modifier, ModifierType } from '@prlw/core/monitor/types/common';

export const defaultAllTableModifier: Modifier = {
  type: ModifierType.BASIC,
};

export const defaultMainTableModifier: Modifier = {
  type: ModifierType.SIMPLE,
};
